import { onMounted, onUnmounted, ref } from "vue";
// throttle
import { throttle } from "lodash";

function isiOS() {
  var userAgent = navigator.userAgent;
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
}

/**
 * 轨迹数据收集
 */
export function useMove() {
  // 存储鼠标轨迹数据的数组
  const mouseTrail = ref([]);

  // 存储触摸轨迹数据的数组
  const touchTrail = ref([]);

  const threshold = 190;

  const isDevToolsOpen = ref(false);
  const checkDev = () => {
    const widthThreshold =
      globalThis.outerWidth - globalThis.innerWidth > threshold;
    const heightThreshold =
      globalThis.outerHeight - globalThis.innerHeight > threshold;
    const ISIOS = isiOS();
    if (
      !ISIOS &&
      !(heightThreshold && widthThreshold) &&
      ((globalThis.Firebug &&
        globalThis.Firebug.chrome &&
        globalThis.Firebug.chrome.isInitialized) ||
        widthThreshold ||
        heightThreshold)
    ) {
      isDevToolsOpen.value = true;
    } else {
      isDevToolsOpen.value = false;
    }
  };

  // 最大数据收集数量
  const maxDataCount = 1000;
  const mouseMove = (event) => {
    const mouseX = event.clientX;
    const mouseY = event.clientY;
    if (mouseX && mouseY) {
      if (mouseTrail.value.length >= maxDataCount) {
        mouseTrail.value.shift(); // 删除最早收集的数据
      }
      const t = new Date().getTime();
      mouseTrail.value.push({ x: mouseX, y: mouseY, t });
    }
  };

  const touchMove = (event) => {
    const touch = event.touches[0];
    const touchX = Math.round(touch.clientX);
    const touchY = Math.round(touch.clientY);
    if (touchX && touchY) {
      if (touchTrail.value.length >= maxDataCount) {
        touchTrail.value.shift(); // 删除最早收集的数据
      }
      const t = new Date().getTime();
      touchTrail.value.push({ x: touchX, y: touchY, t });
    }
  };
  const throttleMouseMove = throttle(mouseMove, 5);
  const throttleTouchMove = throttle(touchMove, 5);
  onMounted(() => {
    // 监听鼠标移动事件
    document.addEventListener("mousemove", throttleMouseMove);
    // 监听触摸事件
    document.addEventListener("touchmove", throttleTouchMove);
  });
  onUnmounted(() => {
    // 移除事件监听
    document.removeEventListener("mousemove", throttleMouseMove);
    document.removeEventListener("touchmove", throttleTouchMove);
  });
  // 清除
  const clear = () => {
    mouseTrail.value = [];
    touchTrail.value = [];
  };

  // 返回鼠标和触摸轨迹数据
  return {
    mouseTrail,
    touchTrail,
    checkDev,
    isDevToolsOpen,
    clear,
  };
}
